// src/services/DB.js
class DB {
  constructor() {
    this.dbName = 'myDatabase';
    this.storeName = 'files';
    this.db = null;
  }

  // Membuka atau membuat database
  openDatabase() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(this.storeName)) {
          db.createObjectStore(this.storeName, { keyPath: 'id' });
        }
      };

      request.onsuccess = (event) => {
        this.db = event.target.result;
        resolve(this.db);
      };

      request.onerror = (event) => {
        reject(event.target.errorCode);
      };
    });
  }

  // Menyimpan data
  save(id, data) {
    return this.openDatabase().then(() => {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([this.storeName], 'readwrite');
        const store = transaction.objectStore(this.storeName);
        const request = store.put({ id, data });

        request.onsuccess = () => {
          resolve('Data saved successfully!');
        };

        request.onerror = (event) => {
          reject('Save error: ' + event.target.errorCode);
        };
      });
    });
  }

  // Mengambil data
  get(id) {
    return this.openDatabase().then(() => {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([this.storeName], 'readonly');
        const store = transaction.objectStore(this.storeName);
        const request = store.get(id);

        request.onsuccess = () => {
          const result = request.result;
          resolve(result ? result.data : null);
        };

        request.onerror = (event) => {
          reject('Get error: ' + event.target.errorCode);
        };
      });
    });
  }

  // Menghapus data
  delete(id) {
    return this.openDatabase().then(() => {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([this.storeName], 'readwrite');
        const store = transaction.objectStore(this.storeName);
        const request = store.delete(id);

        request.onsuccess = () => {
          resolve('Data deleted successfully!');
        };

        request.onerror = (event) => {
          reject('Delete error: ' + event.target.errorCode);
        };
      });
    });
  }
}

export default new DB();
